import arrayTools from '@/technical/arrayTools/arrayTools'

export default function (data, fieldsToAssign) {
  function getSubarrayWithPathToParent (parentObj, pathToParent) {
    var resArray = []
    for (var i = 0; i < data.length; i++) {
      if (data[i].val.pathToParent === pathToParent) {
        // var newElement = window.cloneObject(data[i])
        var newElement = data[i]
        Object.assign(newElement, window.cloneObject(fieldsToAssign))
        newElement.parent = parentObj
        resArray.push(newElement)
      }
    }
    arrayTools.sort(resArray, function (one, two) { return one.val.chainIndx > two.val.chainIndx })
    return resArray
  }

  function setItemChildrenWithPathToParent (item) {
    item.children = getSubarrayWithPathToParent(item, item.val.pathToParent + item.val.id + '.')
    for (var i = 0; i < item.children.length; i++) {
      setItemChildrenWithPathToParent(item.children[i])
    }
  }

  var dataRes = getSubarrayWithPathToParent(null, '.')
  for (var i = 0; i < dataRes.length; i++) {
    setItemChildrenWithPathToParent(dataRes[i])
  }

  return dataRes
}



// WEBPACK FOOTER //
// ./src/technical/components/Treeview/treeviewData.js